import {
  minutesSubscriptionFirst,
  minutesSubscriptionSecond,
  minutesSubscriptionThird,
} from "@/constants/payment";
import { User } from "@/types/types";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";

export const getSecondsToAdd = (
  stripeSubscriptionId: User["stripeSubscriptionId"]
): number | null => {
  const subscriptionPlan = getSubscriptionPlan(stripeSubscriptionId);

  if (subscriptionPlan === "free") {
    return 0;
  } else if (subscriptionPlan === "first") {
    return minutesSubscriptionFirst * 60;
  } else if (subscriptionPlan === "second") {
    return minutesSubscriptionSecond * 60;
  } else if (subscriptionPlan === "third") {
    // minutesSubscriptionThird is unlimited
    return minutesSubscriptionThird;
  }

  // This should never happen
  return 0;
};
